import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration, updateSiteConfigs } from 'actions/Site'
import { fetchCoreApiLog, fetchCoreApiLogDetail, fetchCoreApiLogNames } from 'actions/CoreApiLog'
import CoreApiLogListView from 'components/pages/coreApiLog/List'
import { pickBy, identity } from 'lodash'
import qs from 'query-string'

export function mapStateToProps(state) {
  const {
    isFetching,
    isFetchingDetail,
    dataCoreApiLog,
    metaCoreApiLog,
    detailCoreApiLog,
    apiNames,
  } = state.root.coreApiLog

  return {
    isFetching,
    isFetchingDetail,
    dataCoreApiLog,
    metaCoreApiLog,
    detailCoreApiLog,
    apiNames,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchCoreApiLog: bindActionCreators(fetchCoreApiLog, dispatch),
  fetchCoreApiLogDetail: bindActionCreators(fetchCoreApiLogDetail, dispatch),
  fetchCoreApiLogNames: bindActionCreators(fetchCoreApiLogNames, dispatch),
})

const dataLimit = [
  { id: 1, label: '10' },
  { id: 2, label: '15' },
  { id: 3, label: '25' },
  { id: 4, label: '50' },
  { id: 5, label: '100' },
]

const dataStatus = [
  { id: 1, label: 'success' },
  { id: 2, label: 'failed' },
]

const dataService = [
  { id: 1, label: 'user' },
  { id: 2, label: 'payment' },
]

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('limitList', 'setLimitList', dataLimit),
  withState('statusList', 'setStatusList', dataStatus),
  withState('serviceList', 'setServiceList', dataService),
  withState('stateSearch', 'setStateSearch', {}),
  withState('detailVisible', 'setDetailVisible', false),
  withHandlers({
    onLoad: props => (isSearch) => {
      const {
        page, search, limit, status, service, apiName, startDate, endDate,
      } = props.stateSearch
      const payload = {
        page: isSearch ? '' : page,
        search: search || '',
        status: status || '',
        service: service || '',
        api_name: apiName || '',
        start_date: startDate || '',
        end_date: endDate || '',
        limit: limit || '',
      }
      props.fetchCoreApiLog(`?${qs.stringify(pickBy(payload, identity))}`)
    },
  }),
  withHandlers({
    handleFilter: props => (field, val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        [field]: val,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handleChangeDate: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      let getDateStart = ''
      let getDateEnd = ''
      if (val.length === 2) {
        getDateStart = val[0].format('YYYY-MM-DD')
        getDateEnd = val[1].format('YYYY-MM-DD')
      }
      setStateSearch({
        ...stateSearch,
        startDate: getDateStart,
        endDate: getDateEnd,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handlePage: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        page: val,
      })
      setTimeout(() => {
        onLoad()
      }, 300)
    },
    handleOpenDetail: props => (id) => {
      props.setDetailVisible(true)
      props.fetchCoreApiLogDetail(id)
    },
    handleCloseDetail: props => () => {
      props.setDetailVisible(false)
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'DPLK Core', 'Log API Core'])
      this.props.updateSiteConfigs({
        titlePage: 'Log API Core',
        activePage: 'core-log/api-logs',
        activeSubPage: 'core-log',
      })
      this.props.fetchCoreApiLogNames()
      this.props.fetchCoreApiLog()
    },
  }),
)(CoreApiLogListView)
